import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';

import styles from './styles.module.scss';


const PageLoadingIndicator = ({ inline = false }) => {
  const indicator = <CircularProgress size={80} className={inline ? styles.inlineProgress : styles.progress} />;

  return inline
    ? <div className={styles.inlineWrapper}>{indicator}</div>
    : ReactDOM.createPortal(indicator, document.body);
};

PageLoadingIndicator.propTypes = {
  inline: PropTypes.bool,
};

export default PageLoadingIndicator;
